/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";

import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [{
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/pages/intro'
          //redirect: '/dashboard/analytics'
        },
        {
          path: '/apps/project/main/:projectId',
          redirect: '/apps/project/main/project/:projectId/blog/0'
          //redirect: '/dashboard/analytics'
        },
      ]
    },
    {
      path: '',
      component: () => import('@/layouts/top-main/ExamMain.vue'),
      children: [{
          path: '/app/exam/form',
          name: 'ExamForm',
          component: () => import('@/views/pages/etest-editer/exam/ExamForm.vue'),
          meta: {
            pageTitle: '모든 클래스',
            rule: 'admin'
          }
        },
        {
          path: '/app/practice/form',
          name: 'PracticeForm',
          component: () => import('@/views/pages/epractice-editor/exam/ExamForm.vue'),
          meta: {
            pageTitle: '모든 클래스',
            rule: 'admin'
          }
        },
        {
            path: '/app/exam/edit-form',
            name: 'ExamFormEdit',
            component: () => import('@/views/pages/etest-editer/exam/ExamEditForm.vue'),
            meta: {
              pageTitle: '모든 클래스',
              rule: 'admin'
            }
          }
      ]
    },
    {
      // =============================================================================
      // TOPMAIN LAYOUT ROUTES
      // =============================================================================
      path: '/',
      component: () => import('./layouts/top-main/TopMain.vue'),
      children: [{
          path: '/apps/mypage/main',
          name: 'apps-mypage',
          component: () => import('./views/apps/mypage/profile/Main.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Dashboard',  url: '/apps/mypage/dashboard/main'},
              {
                title: '프로파일',
                active: true
              },
            ],
            pageTitle: '프로파일',
            rule: 'editor'

          },
        },
        {
          path: '/apps/mypage/calendar/:userId',
          name: 'apps-mypage-calendar',
          component: () => import('./views/apps/mypage/calendar/Calendar.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Dashboard',  url: '/apps/mypage/dashboard/main'},
              {
                title: '캘린더',
                active: true
              },
            ],
            pageTitle: '캘린더',
            rule: 'editor'

          },
        },
        {
          path: '/apps/mypage/alarm/id/:id/filter/:filter',
          name: 'apps-mypage-alarm',
          component: () => import('./views/apps/mypage/alarm/Alarm.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Dashboard',  url: '/apps/mypage/dashboard/main'},
              {
                title: '알람',
                active: true
              },
            ],
            pageTitle: '알람',
            rule: 'editor'

          },

        },
        {
          path: '/apps/mypage/password',
          name: 'apps-password',
          component: () => import('./views/apps/mypage/profile/Password.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              {
                title: '프로파일',
                url: '/apps/mypage/main'
              },
              // { title: 'Dashboard',  url: '/apps/mypage/dashboard/main'},
              {
                title: '비밀번호 변경',
                active: true
              },
            ],
            pageTitle: '비밀번호 변경',
            rule: 'editor'

          },
        },
        {
          path: '/apps/mypage/withdrawal',
          name: 'apps-withdrawal',
          component: () => import('./views/apps/mypage/profile/Withdrawal.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              {
                title: '프로파일',
                url: '/apps/mypage/profile/main'
              },
              // { title: 'Dashboard',  url: '/apps/mypage/dashboard/main'},
              {
                title: '회원탈퇴',
                active: true
              },
            ],
            pageTitle: '회원탈퇴',
            rule: 'editor'

          },
        },
      ]
    },
    {
      // =============================================================================
      // TOPMAIN LAYOUT ROUTES
      // =============================================================================
      path: '/',
      component: () => import('./layouts/space-dashboard/SpaceDashboard.vue'),
      children: [

        {
          path: '/apps/space/dashboard/main/:spaceId',
          name: 'apps-space-dashboard',
          component: () => import('./views/apps/space/dashboard/Main.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                active: true
              },
            ],
            pageTitle: 'Home',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/project/:spaceId',
          name: 'apps-space-dashboard-project',
          component: () => import('./views/apps/space/dashboard/Project.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: '프로젝트',
                active: true
              },
            ],
            pageTitle: '프로젝트',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/members/:spaceId',
          name: 'apps-space-dashboard-members',
          component: () => import('./views/apps/space/dashboard/Members.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: '멤버',
                active: true
              },
            ],
            pageTitle: '멤버',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/notice-board/space/:spaceId/id/:boardId',
          name: 'space-dashboard-notice-board',
          component: () => import('./views/apps/space/dashboard/NoticeBoard.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: 'QnA',
                active: true
              },
            ],
            pageTitle: 'QnA',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/student-notice/space/:spaceId/id/:stdNoticeId',
          name: 'space-dashboard-student-notice',
          component: () => import('./views/apps/space/dashboard/StudentNotice.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: '게시판',
                active: true
              },
            ],
            pageTitle: '게시판',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/notice/space/:spaceId/id/:noticeId',
          name: 'space-dashboard-notcie',
          component: () => import('./views/apps/space/dashboard/Notice.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: '공지사항',
                active: true
              },
            ],
            pageTitle: '공지사항',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/submit/space/:spaceId/id/:submitId',
          name: 'space-dashboard-submit',
          component: () => import('./views/apps/space/dashboard/Submit.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: '결과물제출',
                active: true
              },
            ],
            pageTitle: '결과물제출',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/online-test/space/:spaceId/id/:onlineTestId',
          name: 'space-dashboard-online-test',
          component: () => import('./views/apps/space/dashboard/OnlineTest.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: '온라인테스트',
                active: true
              },
            ],
            pageTitle: '온라인테스트',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/attend/space/:spaceId/id/:attendId',
          name: 'space-dashboard-attend',
          component: () => import('./views/apps/space/dashboard/Attend.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: '전자 출석',
                active: true
              },
            ],
            pageTitle: '전자 출석',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/attend-user/space/:spaceId/id/:userId',
          name: 'space-dashboard-attend-user',
          component: () => import('./views/apps/space/dashboard/attend/AttendUser.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: '전자 출석',
                url: '/apps/space/dashboard/attend/space/:spaceId/id/0'
              },
              {
                title: '개별출석부',
                active: true
              },
            ],
            pageTitle: '개별출석부',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/insight/space/:spaceId/id/:insightId',
          name: 'space-dashboard-insight',
          component: () => import('./views/apps/space/dashboard/Insight.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: '인사이트',
                active: true
              },
            ],
            pageTitle: '출석부',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/insight-user/space/:spaceId/id/:userId',
          name: 'space-dashboard-insight-user',
          component: () => import('./views/apps/space/dashboard/insight/InsightUser.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: '인사이트',
                url: '/apps/space/dashboard/insight/space/:spaceId/id/0'
              },
              {
                title: '개별인사이트',
                active: true
              },
            ],
            pageTitle: '개별인사이트',
            rule: 'editor'
          },
        },
        {
          path: '/apps/space/dashboard/insight-team/space/:spaceId/project/:projectId',
          name: 'space-dashboard-insight-team',
          component: () => import('./views/apps/space/dashboard/insight/InsightTeam.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Home',
                url: '/apps/space/dashboard/main/0'
              },
              {
                title: '인사이트',
                url: '/apps/space/dashboard/insight/space/:spaceId/id/0'
              },
              {
                title: '팀인사이트',
                active: true
              },
            ],
            pageTitle: '팀인사이트',
            rule: 'editor'
          },
        },
      ]
    },
    // =============================================================================
    // TASKTOPMAIN LAYOUT ROUTES
    // =============================================================================
    {
      path: '/',
      component: () => import('./layouts/top-main/TaskTopMain.vue'),
      children: [{
          path: '/apps/project/main/project/:projectId/blog/:blogId',
          // path: '/apps/project/main',
          name: 'page-task-main',
          component: () => import('@/views/apps/pms/PMSMain.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/apps/project/insight/project/:projectId/user/:userId',
          name: 'page-task-insight',
          component: () => import('./views/apps/pms/insight/InsightUser.vue'),
          meta: {
            rule: 'editor'
          },
        },
      ]
    },
    {
      // =============================================================================
      // TOPSERCHMAIN LAYOUT ROUTES
      // =============================================================================
      path: '/',
      component: () => import('./layouts/top-main/TopETestMain.vue'),
      children: [{
        path: '/apps/etest',
        name: 'apps-etest',
        component: () => import('./views/pages/etest-editer/Main.vue'),
        meta: {
          pageTitle: '모든 클래스',
          rule: 'admin'
        }
      }, {
        path: '/apps/epractice',
        name: 'apps-epractice',
        component: () => import('./views/pages/epractice-editor/Main.vue'),
        meta: {
          pageTitle: '모든 클래스',
          rule: 'admin'
        }
      }, {
        path: '/apps/admin/etest',
        name: 'admin-etest',
        component: () => import('./views/pages/admin-etest/Main.vue'),
        meta: {
          pageTitle: '모든 클래스',
          rule: 'superAdmin'
        }
      },{
        path: '/apps/admin/etest-form',
        name: 'admin-etest-form',
        component: () => import('./views/pages/admin-etest-list/Main.vue'),
        meta: {
          pageTitle: '모든 클래스',
          rule: 'superAdmin'
        }
      },{
        path: '/apps/admin/college-form',
        name: 'admin-college-form',
        component: () => import('./views/pages/admin-college/Main.vue'),
        meta: {
          pageTitle: '모든 클래스',
          rule: 'superAdmin'
        }
      },{
        path: '/apps/admin/college-simply',
        name: 'admin-college-simply',
        component: () => import('./views/pages/admin-college/CollegeSimply.vue'),
        meta: {
          pageTitle: '모든 클래스',
          rule: 'superAdmin'
        }
      },{
        path: '/apps/admin/user-search',
          name: 'user-search',
          component: () => import('./views/pages/user-search/Main.vue'),
          meta: {
            pageTitle: '모든 클래스',
            rule: 'superAdmin'
          }
      },{
        path: '/apps/etest/editer/:activeId',
        name: 'apps-etest-editer',
        component: () => import('./views/pages/etest-editer/exam/Main.vue'),
        meta: {
          pageTitle: '모든 클래스',
          rule: 'admin'
        }
      }, ]
    },
    {
      // =============================================================================
      // TOPSERCHMAIN LAYOUT ROUTES
      // =============================================================================
      path: '/',
      component: () => import('./layouts/top-main/TopSerchMain.vue'),
      children: [{
          path: '/pages/space/create',
          name: 'page-create-space',
          component: () => import('@/views/pages/space/CreateSpace.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/space/invite',
          name: 'page-invite-space',
          component: () => import('@/views/pages/space/InviteSpace.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/apps/space',
          name: 'apps-space',
          component: () => import('./views/apps/space/Space.vue'),
          meta: {

            pageTitle: '모든 클래스',
            rule: 'editor'
          }
        },
        {
          path: '/apps/space/all',
          name: 'Space-all',
          component: () => import('./views/apps/space/SpaceAll.vue'),
          meta: {
            // breadcrumb: [
            //     { title: 'Home', url: '/dist/apps/space' },
            //     // { title: 'Card' },
            //     { title: 'Space', active: true },
            // ],
            pageTitle: '모든 클래스',
            rule: 'editor'
          }
        },
        {
          path: '/pages/project/create',
          name: 'page-create-project',
          component: () => import('@/views/pages/project/CreateProject.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/project/invite',
          name: 'page-invite-project',
          component: () => import('@/views/pages/project/InviteProject.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/apps/project',
          name: 'apps-project',
          component: () => import('./views/apps/project/Project.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/apps/space'
              },
              // { title: 'Card' },
              {
                title: 'Project',
                active: true
              },
            ],
            pageTitle: 'Statistics Card',
            rule: 'editor'
          },
        },
        {
          path: '/apps/timetable/:userId',
          name: 'apps-timeTable',
          component: () => import('@/views/apps/mypage/timeTable/TimeTable.vue'),
          meta: {
            rule: 'editor'
          }
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
            path: '/app/exam/form/:questionId',
            name: 'ExamFormView',
            component: () => import('@/views/pages/etest-editer/exam/ExamFormView.vue'),
            meta: {
              pageTitle: '모든 클래스',
              rule: 'admin'
            }
        },
        {
          path: '/pages/intro',
          name: 'page-intro',
          component: () => import('@/views/pages/intro/Intro.vue'),
          meta: {
            rule: 'public'
          }
        },
        // {
        //   path: '/pages/intro-pulda',
        //   name: 'page-intro-pulda',
        //   component: () => import('@/views/pages/intro/IntroPulda.vue'),
        //   meta: {
        //     rule: 'public'
        //   }
        // },
        // {
        //   path: '/pages/intro-pulda',
        //   name: 'page-intro-pulda',
        //   component: () => import('@/views/pages/main_v2/web/main/Main.vue'),
        //   meta: {
        //     rule: 'public'
        //   }
        // },
        // {
        //   path: '/pages/intro-pulda-mobile',
        //   name: 'page-intro-pulda-mobile',
        //   component: () => import('@/views/pages/intro/IntroPuldaMobile.vue'),
        //   meta: {
        //     rule: 'public'
        //   }
        // },
        {
          path: '/pages/intro-test',
          name: 'page-intro-test',
          component: () => import('@/views/pages/intro/pulda/IntroTest.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/intro-plan',
          name: 'page-intro-plan',
          component: () => import('@/views/pages/intro/pulda/IntroPlan.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/intro-today',
          name: 'page-intro-today',
          component: () => import('@/views/pages/intro/pulda/IntroToday.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/intro-main',
          name: 'page-intro-main',
          component: () => import('@/views/pages/intro/pulda/IntroMain.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/insight',
          name: 'page-insight',
          component: () => import('@/views/pages/insight/Main.vue'),
          meta: {
            rule: 'public'
          }
        },
        // {
        //   path: '/pages/gugudan',
        //   name: 'page-gugudan',
        //   component: () => import('@/views/pages/intro/gugudan.vue'),
        //   meta: {
        //     rule: 'public'
        //   }
        // },
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/privacy',
          name: 'page-privacy',
          component: () => import('@/views/pages/login/Privacy.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/terms-of-use',
          name: 'page-terms-of-use',
          component: () => import('@/views/pages/login/Terms.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/password',
          name: 'page-change-password',
          component: () => import('@/views/pages/change-password/ChangePassword.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/login/password',
          name: 'page-login-change-password',
          component: () => import('@/views/pages/change-password/LoginChangePassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/accept/:workspaceId',
          name: 'page-accept-space',
          component: () => import('@/views/pages/space/AcceptCode.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        },
      ]
    },
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPageTopNavbarHorizontal.vue'),
      children: [
        {
          path: '/pages/intro-pulda',
          name: 'page-intro-pulda',
          component: () => import('@/views/pages/main_v2/web/main/Main.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/pages/introduction',
          name: 'page-introduction',
          component: () => import('@/views/pages/main_v2/web/introduction/Main.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/pages/production',
          name: 'page-production',
          component: () => import('@/views/pages/main_v2/web/production/Main.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/pages/contact',
          name: 'page-contact',
          component: () => import('@/views/pages/main_v2/web/ask/Main.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/pages/join-us',
          name: 'page-join',
          component: () => import('@/views/pages/main_v2/web/recruitment/Main.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/pages/privacy-policy',
          name: 'privacy-Policy',
          component: () => import('@/views/pages/main_v2/web/content/PrivacyPolicy.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/pages/news',
          name: 'news',
          component: () => import('@/views/pages/main_v2/web/content/Article.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/mobile/pages/intro-pulda',
          name: 'intro-pulda-mobile',
          component: () => import('@/views/pages/main_v2/mobile/main/Main.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/mobile/pages/introduction',
          name: 'page-introduction-mobile',
          component: () => import('@/views/pages/main_v2/mobile/introduction/Main.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/mobile/pages/production',
          name: 'page-production-mobile',
          component: () => import('@/views/pages/main_v2/mobile/production/Main.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/mobile/pages/contact',
          name: 'page-contact-mobile',
          component: () => import('@/views/pages/main_v2/mobile/contact/Main.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/mobile/pages/join-us',
          name: 'page-join-mobile',
          component: () => import('@/views/pages/main_v2/mobile/recruitment/Main.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/mobile/pages/privacy-policy',
          name: 'privacy-Policy-mobile',
          component: () => import('@/views/pages/main_v2/mobile/content/PrivacyPolicy.vue'),
          meta: {
            rule: 'public'
          }
        },{
          path: '/mobile/pages/news',
          name: 'news-mobile',
          component: () => import('@/views/pages/main_v2/mobile/content/Article.vue'),
          meta: {
            rule: 'public'
          }
        },
      ]
    },
    // Redirect to 404 page, if no match found

    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {

    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser

    // if (
    //     to.path === "/pages/login" ||
    //     to.path === "/pages/forgot-password" ||
    //     to.path === "/pages/error-404" ||
    //     to.path === "/pages/error-500" ||
    //     to.path === "/pages/register" ||
    //     to.path === "/callback" ||
    //     to.path === "/pages/comingsoon" ||
    //     (auth.isAuthenticated() || firebaseCurrentUser)
    // ) {
    //     return next();
    // }

    // If auth required, check login. If login fails redirect to login page
    if (to.meta.authRequired) {
      if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
        router.push({
          path: '/pages/login',
          query: {
            to: to.path
          }
        })
      }
    }

    return next()
    // Specify the current path as the customState parameter, meaning it
    // will be returned to the application after auth
    // auth.login({ target: to.path });

  });

});

export default router
